import apiConfig from '../../../apiConfig';

export const fetchOpenDatesForStaffReserve = async (
  storeId: number,
  staffId: number,
  days: number = 30,
): Promise<string[]> => {
  const url = new URL(`${apiConfig.baseURL}/api/customer-app/reservation/by-staff/open-dates`);
  url.searchParams.set('store_id', String(storeId));
  url.searchParams.set('staff_id', String(staffId));
  url.searchParams.set('days', String(days));

  const res = await fetch(url.toString(), { method: 'GET' });
  if (!res.ok) {
    throw new Error('Failed to fetch open dates (by-staff)');
  }

  const data = (await res.json()) as { open_dates?: string[] };
  return data.open_dates ?? [];
};
